// @flow
/* global $Diff */

import * as React from 'react';

export const ScaleContext: React.Context<number> = React.createContext(1);

export const injectScale = <Props: {}>(
  Component: React.ComponentType<Props>
): React.ComponentType<$Diff<Props, { scale: number | void }>> => {
  const ComponentWithScale = (props: Props) => {
    return <ScaleContext.Consumer>{scale => <Component {...props} scale={scale} />}</ScaleContext.Consumer>;
  };

  const displayName = Component.displayName || Component.name || 'Component';
  ComponentWithScale.displayName = `InjectScale${displayName}`;

  return ComponentWithScale;
};
